import React, { useContext, useEffect } from 'react';
import { IconToggle, IconToggleContainer } from '../../PreviewPage/IconToggle';
import { ImageCropperContext } from '../../../libs/gs-component-image-upload';

interface Props {
  defaultRatioName?: string;
  defaultRatio?: number;
  trackCoverPhotoAction?: (action: string, ratioName: string) => void;
}

export const HORIZONTAL_ICON = 'wws_horizontal_layout';
export const VERTICAL_ICON = 'wws_vertical_layout';
export const HORIZONTAL_RATIO = 2;
export const VERTICAL_RATIO = 0.8;
export const LAYOUT_ASPECT_RATIO: { [key: string]: number } = {
  wws_horizontal_layout: HORIZONTAL_RATIO,
  wws_vertical_layout: VERTICAL_RATIO,
};

const LayoutToggle: React.FC<Props> = ({
  defaultRatio = HORIZONTAL_RATIO,
  defaultRatioName = HORIZONTAL_ICON,
  trackCoverPhotoAction,
}) => {
  const defaultHorizontalLayout = defaultRatioName === HORIZONTAL_ICON;
  const [horizontalLayout, setHorizontalLayout] = React.useState<boolean>(defaultHorizontalLayout);
  const { updateAspectRatio } = useContext(ImageCropperContext);

  const handleLayoutChange = (ratioName: string) => {
    setHorizontalLayout(!horizontalLayout);
    // updates cropper aspect ratio
    updateAspectRatio(LAYOUT_ASPECT_RATIO[ratioName]);
    trackCoverPhotoAction && trackCoverPhotoAction('layout_selection', ratioName);
  };

  useEffect(() => {
    updateAspectRatio(defaultRatio);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultRatio]);

  return (
    <IconToggleContainer size="sm" changeSelectedPreview={handleLayoutChange} updatedColors>
      <IconToggle selected={horizontalLayout} icon={HORIZONTAL_ICON} iconLabel="Horizontal" />
      <IconToggle selected={!horizontalLayout} icon={VERTICAL_ICON} iconLabel="Vertical" />
    </IconToggleContainer>
  );
};

export default LayoutToggle;
